import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@citiguide/ui-components';
import { useCurationStore } from '../../store/curationStore';
import { usePlansStore } from '../../store/plansStore';
import PinnedPlaces from './PinnedPlaces';

/**
 * Shown while a plan is open from a shared link (`pins` / `pn` in the URL): the plan name, its pinned
 * places, and "Save to My plans". Closing it removes the params from the URL.
 */
export default function SharedPlanBanner() {
  const { t } = useTranslation();
  const openPlan = useCurationStore((s) => s.openPlan);
  const closePlan = useCurationStore((s) => s.closePlan);
  const [saved, setSaved] = useState(false);
  // Only a plan opened from a link (no saved id). A plan opened from My plans is shown in the chat panel.
  if (!openPlan || openPlan.id) return null;

  const save = () => {
    const { state, pinnedMarkerIds } = useCurationStore.getState();
    const plan = usePlansStore.getState().save({
      name: openPlan.name || t('plans.sharedUnnamed'),
      state,
      pinnedMarkerIds,
    });
    if (plan) setSaved(true);
  };

  return (
    <aside className="shared-plan" aria-label={t('plans.sharedUnnamed')}>
      <div className="shared-plan__head">
        <strong>{openPlan.name ? t('plans.shared', { name: openPlan.name }) : t('plans.sharedUnnamed')}</strong>
        <button type="button" className="shared-plan__close" aria-label={t('plans.closeBanner')} onClick={closePlan}>
          ×
        </button>
      </div>
      <PinnedPlaces removable={false} />
      {saved ? (
        <p role="status">{t('plans.savedToMyPlans')}</p>
      ) : (
        <Button size="sm" onClick={save}>{t('plans.saveToMyPlans')}</Button>
      )}
    </aside>
  );
}
